const API_URL = process.env.REACT_APP_API_URL || "https://backtest-1xfz.onrender.com/api";

export async function login(email, mot_de_passe) {
  const res = await fetch(`${API_URL}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, mot_de_passe }),
  });
  return await res.json();
}

// Fonction pour l'inscription
export async function register(nom, email, mot_de_passe) {
  const res = await fetch(`${API_URL}/auth/register`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ nom, email, mot_de_passe }),
  });
  return await res.json();
}

export async function getProfile(token) {
  const res = await fetch(`${API_URL}/me`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.json();
}

export async function updateProfile(token, data) {
  const res = await fetch(`${API_URL}/me`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(data)
  });
  if (!res.ok) {
    let message = `Erreur update (${res.status})`;
    try {
      const body = await res.json();
      if (body && body.message) message = body.message;
    } catch (_) {
      // ignore JSON parse errors
    }
    throw new Error(message);
  }
  return await res.json();
}

// Liste des clients
export async function getClients(token) {
  try {
    const res = await fetch(`${API_URL}/clients`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    
    const data = await res.json();
    
    // Ensure we return an array
    if (Array.isArray(data)) {
      return data;
    } else if (data && data.message) {
      // If it's an error response, throw an error
      throw new Error(data.message);
    } else {
      // If it's not an array and not an error, return empty array
      console.warn("Unexpected response format from getClients:", data);
      return [];
    }
  } catch (error) {
    console.error("Error in getClients:", error);
    throw error;
  }
}

// Compter les clients
export async function getClientsCount(token) {
  try {
    const res = await fetch(`${API_URL}/clients/count`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    
    const data = await res.json();
    
    // Ensure we return the expected structure
    if (data && typeof data.count === 'number') {
      return data;
    } else if (data && data.message) {
      // If it's an error response, throw an error
      throw new Error(data.message);
    } else {
      // If it's not the expected format, return default structure
      console.warn("Unexpected response format from getClientsCount:", data);
      return { count: 0 };
    }
  } catch (error) {
    console.error("Error in getClientsCount:", error);
    throw error;
  }
}

// Ajouter un client
export async function addClient(token, data) {
  const res = await fetch(`${API_URL}/clients`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(data)
  });
  return res.json();
}

// Modifier un client
export async function updateClient(token, id, data) {
  const res = await fetch(`${API_URL}/clients/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(data)
  });
  return res.json();
}

// Supprimer un client
export async function deleteClient(token, id) {
  const res = await fetch(`${API_URL}/clients/${id}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.json();
}

// Liste des devis
export async function getDevis(token) {
  const res = await fetch(`${API_URL}/devis`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.json();
}

// Créer un devis
export async function createDevis(token, data) {
  const res = await fetch(`${API_URL}/devis`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(data)
  });
  return res.json();
}

// Récupérer un devis par ID
export async function getDevisById(token, id) {
  const res = await fetch(`${API_URL}/devis/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.json();
}

// Modifier un devis
export async function updateDevis(token, id, data) {
  const res = await fetch(`${API_URL}/devis/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(data)
  });
  return res.json();
}

// Supprimer un devis
export async function deleteDevis(token, id) {
  const res = await fetch(`${API_URL}/devis/${id}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.json();
}

// ===== API SECTIONS =====

// Récupérer tous les types de sections disponibles
export async function getSectionTypes(token) {
  const res = await fetch(`${API_URL}/sections/types`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.json();
}

// Récupérer les sous-sections d'un type de section
export async function getSousSections(token, sectionTypeId) {
  const res = await fetch(`${API_URL}/sections/types/${sectionTypeId}/sous-sections`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.json();
}

// Récupérer les items d'une sous-section
export async function getItems(token, sousSectionTypeId) {
  const res = await fetch(`${API_URL}/sections/sous-sections/${sousSectionTypeId}/items`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.json();
}

// Récupérer les sous-items d'un item
export async function getSousItems(token, itemTypeId) {
  const res = await fetch(`${API_URL}/sections/items/${itemTypeId}/sous-items`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.json();
}

// Ajouter une section à un devis
export async function addSectionToDevis(token, devisId, data) {
  const res = await fetch(`${API_URL}/sections/devis/${devisId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(data)
  });
  return res.json();
}

// Ajouter une sous-section à une section
export async function addSousSectionToSection(token, sectionInstanceId, data) {
  const res = await fetch(`${API_URL}/sections/sections/${sectionInstanceId}/sous-sections`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(data)
  });
  return res.json();
}

// Ajouter un item à une sous-section
export async function addItemToSousSection(token, sousSectionInstanceId, data) {
  const res = await fetch(`${API_URL}/sections/sous-sections/${sousSectionInstanceId}/items`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(data)
  });
  return res.json();
}

// Récupérer la structure complète d'un devis
export async function getDevisStructure(token, devisId) {
  const res = await fetch(`${API_URL}/sections/devis/${devisId}/structure`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.json();
}

// Supprimer une section d'un devis
export async function deleteSection(token, sectionInstanceId) {
  const res = await fetch(`${API_URL}/sections/sections/${sectionInstanceId}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.json();
}

// Générer un PDF d'un devis
export const generateDevisPDF = async (token, id) => {
  const response = await fetch(`${API_URL}/devis/${id}/pdf`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  if (!response.ok) throw new Error('Erreur lors de la génération du PDF');
  return response.json();
};

// Envoyer le devis par mail
export async function sendDevisByEmail(token, devisId) {
  try {
    const res = await fetch(`${API_URL}/devis/${devisId}/send-email`, {
      method: "POST",
      headers: { 
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    
    if (!res.ok) {
      const errorData = await res.json();
      throw new Error(errorData.message || `Erreur HTTP! status: ${res.status}`);
    }
    
    return await res.json();
  } catch (error) {
    console.error("Error in sendDevisByEmail:", error);
    throw error;
  }
}

